<router-outlet></router-outlet>
<div *ngIf="(modelsService.hourglass | async)" class="hourglass">
  <div></div>
</div>
<app-toast></app-toast>
